import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      foldername: "",
      company: this.$store.state.company,
      user: this.$store.state.user,
      error: false,
    };
  },
  created() {
    setTimeout(() => {
      if (this.$refs.foldername) {
        this.$refs.foldername.focus();
      }
    }, 300);
  },
  methods: {
    addFolder() {
      let formData = new FormData();

      formData.append("foldername", this.foldername);

      if (this.data.mySpace === 1) {
        //is my space
        formData.append(
          "folder",
          this.data.folderId ? this.data.folderId : "null"
        );
      } else {
        //is other space
        formData.append("folder", this.data.folderId);
        formData.append("description", "");
        formData.append("color", "000");
        formData.append("private", 0);
      }

      formData.append("myspace", this.data.mySpace);

      this.$axios.post(baseUrl + "/folderadd", formData).then((response) => {
        if (
          response.data.success == false &&
          response.data.msg == "folder_exists"
        ) {
          this.error = true;
        }
        if (
          response.data.success == true &&
          response.data.msg == "folder_added"
        ) {
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        }
      });
    },
  },
};
